/**
 * @author czy
 * 功能：凭证模版
 */

import { Service } from '@/tools'

export class TemplateConfigService<T extends TSettle.TemplateConfig> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.TemplateConfig}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 模版配置tree /api/settle/templateConfig/v1/findListByParentId
  findListByParentId = <K extends T['ApiFindListByParentId']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiFindListByParentId', data)

  // 获取模板配置详情 /api/settle/templateConfig/v1/detail
  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)
}
